export default "__VITE_ASSET__DgQA5SyG__"